// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import { useSSRExperimentVariant } from '@nykaa/experiment-sdk/store/hooks';

const useCustomerGlue = () => {
  const { enabled, config } = useRemoteConfig('customerGlue');
  const cgExperimentId = config.experimentId || '';
  const { variant, isEligible } = useSSRExperimentVariant(cgExperimentId);

  let isCGEnabled = true;

  // if customer glue is not enabled, return false
  if (enabled === false) {
    isCGEnabled = false;
  }

  // if experiment id not defined in remote config, return false
  if (!cgExperimentId) {
    isCGEnabled = false;
  }

  // if user is not eligible for customer experiment, return false
  if (isEligible === false) {
    isCGEnabled = false;
  }

  // if user is not in customer glue variant, return false
  if (variant !== config.experimentVariant) {
    isCGEnabled = false;
  }

  return { isCGEnabled, config };
};

export default useCustomerGlue;
